import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Input from '../Input';

const PQ_COMMENT_ID = /^(.*\.tracking\.pqComments)\[(\d+)\]\.pqComment$/;

/**
 * PQ Additional Comments: only the latest comment of a product is editable,
 * and only until the PQ subcase is submitted, completed without submission
 * or archived. Returns null for any other field so its `disabled` is untouched.
 */
export const isPqCommentLocked = ({ $id, model }) => {
  const match = PQ_COMMENT_ID.exec($id || '');
  if (!match) return null;
  const comments = get(model, match[1]) || [];
  const isLatest = Number(match[2]) >= comments.length - 1;
  const pq = get(model, 'subcases.productQuality') || {};
  // `submitted` is reset to false when a new version is created (createNewSubcaseVersion)
  const isSubcaseClosed =
    pq.submitted === true || /COMPLETED|ARCHIVED/.test(pq.status || '');
  return isSubcaseClosed || !isLatest;
};

// Same checks as withDataWrapper, which runs first and also folds in the schema's
// `disabled`; they're repeated here because the PQ rule replaces that schema value
const isFormLocked = ({ data = {} }) =>
  !!data.isCaseLocked || !!data.isReadOnly;

const TextArea = props => {
  const pqLocked = isPqCommentLocked(props);
  const disabled =
    pqLocked === null ? props.disabled : pqLocked || isFormLocked(props);
  return (
    <Input {...props} disabled={disabled} type="textarea">
      <textarea />
    </Input>
  );
};

TextArea.propTypes = {
  disabled: PropTypes.bool
};

TextArea.defaultProps = {
  disabled: false
};

export default TextArea;
